import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { syncDirectusAuth, logoutUser } from '../store/slices/authSlice';
import { authManager } from '../lib/directus';

/**
 * Hook to keep Redux auth state synchronized with DirectusAuthManager
 * Ensures consistent authentication state across the application
 */
export const useAuthStateSync = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Set up Redux dispatch for auth manager to trigger logout
    authManager.setStoreDispatch(dispatch);

    // Subscribe to auth manager state changes
    const unsubscribe = authManager.subscribe((authState) => {
      console.log('🔄 Auth state changed:', { 
        isAuthenticated: authState.isAuthenticated, 
        hasUser: !!authState.user,
        hasError: !!authState.error 
      });

      // Sync Redux state with DirectusAuthManager state
      dispatch(syncDirectusAuth({
        user: authState.user,
        isAuthenticated: authState.isAuthenticated
      }));

      // If authentication failed due to token expiration, logout
      if (!authState.isAuthenticated && authState.error) {
        const errorMessage = authState.error.toLowerCase();
        if (errorMessage.includes('token expired') || 
            errorMessage.includes('session expired') ||
            errorMessage.includes('unauthorized')) {
          console.log('🚪 Auto-logout due to token expiration');
          dispatch(logoutUser());
        }
      }
    });

    return unsubscribe;
  }, [dispatch]);

  // Return auth manager for direct access if needed
  return { authManager };
};